import ServerError from '@/common/ServerError'

export default class GenericService {
  constructor(axios) {
    this.axios = axios
  }

  async get(path) {
    try {
      const { data: { data } } = await this.axios.get(path)
      return data
    } catch (error) {
      throw new ServerError(error)
    }
  }

  async myGet(url, params = {}) {
    return this.axios({
      url,
      method: 'get',
      params,
    })
  }

  async myPost(url, data = {}) {
    return this.axios({
      url,
      method: 'post',
      data,
    })
  }
}
